import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Hero from "./Hero";
import AboutSection from "./AboutSection";
import ServicesSection from "./ServicesSection";
import AdvantagesSection from "./AdvantagesSection";
export function MainPage() {
    return (_jsxs(_Fragment, { children: [_jsx(Hero, {}), _jsx(AboutSection, {}), _jsx(ServicesSection, {}), _jsx(AdvantagesSection, {})] }));
}
